import { BUILDINGS } from '../constants';
import { createGameEngine, resetGameEngine } from '../GameEngine';
import { createEmptyPlayerInventory } from '../GameState';
import { TestDefinition, assert } from '../TestRunner';

const beltBuilding = BUILDINGS.BELT;

const collisionRebuildAfterDeconstructTest: TestDefinition = {
  name: 'Collision data rebuilds after deconstructing a building',
  description:
    'After removing a building, the collision system should immediately allow placing another building on the same tile without requiring extra actions.',
  testFunction: async () => {
    resetGameEngine();

    const position = { x: 25, y: 25 };
    const key = `${position.x},${position.y}`;

    const initialInventory = createEmptyPlayerInventory();
    initialInventory[0] = { itemType: 'iron-plate', count: 10 };

    const engine = createGameEngine({
      playerInventory: initialInventory,
      buildingLayer: {
        [key]: beltBuilding.character,
      },
    });

    const collisionService = engine.getCollisionService();

    const validationBeforeRemoval = collisionService.validateBuildingPlacement(
      beltBuilding,
      position.x,
      position.y
    );

    assert.isTrue(
      !validationBeforeRemoval.isValid,
      'Existing building should block placement before deconstruction'
    );

    const deconstructed = engine.deconstructBuilding(position.x, position.y);

    assert.isTrue(
      deconstructed,
      'Deconstruction should succeed when a building occupies the tile'
    );

    const validationAfterRemoval = collisionService.validateBuildingPlacement(
      beltBuilding,
      position.x,
      position.y
    );

    assert.isTrue(
      validationAfterRemoval.isValid,
      'Collision system should allow placement immediately after deconstruction'
    );

    const placementResult = engine.placeBuilding(
      position.x,
      position.y,
      beltBuilding
    );

    assert.isTrue(
      placementResult,
      'Placement should succeed without needing an extra collision refresh'
    );

    resetGameEngine();

    return {
      name: 'Collision data rebuilds after deconstruction',
      passed: true,
      message:
        'Collision system was rebuilt immediately after deconstructing a building.',
      duration: 0,
      details: {
        validationAfterRemoval: validationAfterRemoval.isValid,
      },
    };
  },
};

export const collisionSystemTests: TestDefinition[] = [
  collisionRebuildAfterDeconstructTest,
];
